<div class="PGLoginHandler">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    
    @if (userRequest == null) {
        <div class="form-group">
            <label for="pg-login-email">
                <b>{{ 'pg-login-handler.input-email' | locTranslate }}</b>
            </label>
            <input id="pg-login-email" type="email" class="form-control" ngbAutofocus [(ngModel)]="loginUsername" placeholder="email@website.com" autocomplete="username" (keyup)="onLoginDefaultKeyUp($event)" [attr.aria-invalid]="loginError || null" [attr.aria-describedby]="loginError ? 'pg-login-error' : null"/>
        </div>
        <div class="form-group mb-0">
            <label for="pg-login-password">
                <b>{{ 'pg-login-handler.input-password' | locTranslate }}</b>
            </label>
            <input id="pg-login-password" type="password" class="form-control" [(ngModel)]="loginPassword" placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;" autocomplete="current-password" (keyup)="onLoginDefaultKeyUp($event)" [attr.aria-invalid]="loginError || null" [attr.aria-describedby]="loginError ? 'pg-login-error' : null"/>
        </div>
        <div class="d-flex justify-content-between mt-1">
            <div>
                <button type="button" class="btn btn-link btn-sm p-0" (click)="startPasswordRecover()">{{ 'pg-login-handler.password-recover' | locTranslate }}</button>
            </div>
            <div>
                <button type="button" class="btn btn-link btn-sm p-0" (click)="startCreateAccount()">{{ 'pg-login-handler.create-account' | locTranslate }}</button>
            </div>
        </div>
        <div class="form-group">
            @if (loginError) {
                <div id="pg-login-error" class="text-danger" role="alert">{{ 'pg-login-handler.login-failed' | locTranslate }}</div>
            }
        </div>
        <button type="button" class="btn btn-primary btn-block" [disabled]="!canLoginDefault()" (click)="doLoginDefault()">
            <i class="fa-regular fa-sign-in-alt" aria-hidden="true"></i>
            <span>{{ 'pg-login-handler.button-login' | locTranslate }}</span>
        </button>

        @if (hasSSOLogin.google || hasSSOLogin.cohesion) {
            <hr/>
        }

        @if (hasSSOLogin.google) {
            <button type="button" class="btn btn-primary btn-block" (click)="doSSOLogin('google')">
                <i class="fa-brands fa-google" aria-hidden="true"></i>
                <span>{{ 'pg-login-handler.button-login-with-google' | locTranslate }}</span>
            </button>
        }
        
        @if (hasSSOLogin.cohesion) {
            <button type="button" class="btn btn-primary btn-block" (click)="doSSOLogin('cohesion')">
                <img class="PGLoginHandler-Cohesion-Image" src="assets/images/marche_stema_white 1.svg" alt="" aria-hidden="true">
                <span>{{ 'pg-login-handler.button-login-with-cohesion' | locTranslate }}</span>
            </button>
        }
    }

    @if (userRequest != null) {
        <div class="mb-3">
            <button type="button" class="btn btn-link btn-sm p-0" (click)="cancelUserRequest()">
                <i class="fa-regular fa-chevron-left" aria-hidden="true"></i>
                <span>{{ 'pg-login-handler.cancel-' + userRequest | locTranslate }}</span>
            </button>
        </div>
        <p class="text-muted mb-3">
            {{'pg-login-handler.subtitle-' + userRequest | locTranslate}}
        </p>

        <app-pg-login-handler-otp [noBack]="true" (afterLogin)="doUserRequest()"></app-pg-login-handler-otp>
    }
</div>
